/**
 * Footer component.
 * @module components/theme/Logo/Logo
 */
import { injectIntl } from 'react-intl';
import LocalFooter from '../../../../../components/Footer/Footer';

const Footer = () => {
  return <LocalFooter />;
};

export default injectIntl(Footer);
